import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from './auth.service';
import {UserService} from './user.service';
import {Observable} from 'rxjs';

@Injectable()
export class AdminGuardService  {

	constructor(
		private auth: AuthService,
		private userService: UserService,
		private router: Router
	) {
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {

		this.auth.renewTokens();

		if (!this.auth.isAuthenticated()) {

			localStorage.setItem('authRedirect', state.url);
			this.router.navigate(['login']);

			return false;
		} else {
			return this.userService.isAdminPromise();
		}
	}

	async sleep(msec) {
		return new Promise(resolve => setTimeout(resolve, msec));
	}
}
